/**
 * Small status pill for publish rights. Reuses the design-system Badge so it
 * inherits dark-mode + focus styles. Generic over canPublish so it works for
 * any future entitlement source unchanged.
 */
import { Badge } from '@/src/modules/components/ui/badge';

export function EntitlementStatusBadge({ canPublish }: { canPublish: boolean }) {
  return (
    <Badge variant={canPublish ? 'default' : 'destructive'}>
      {canPublish ? 'Active' : 'No Credits Remaining'}
    </Badge>
  );
}
